export function SadeSatiPhases() {
  return (
    <div className="card-sacred p-6 sm:p-8 mt-6">
      <h2
        className="text-[18px] font-bold mb-4"
        style={{
          fontFamily: "var(--font-pt-serif), PT Serif, Georgia, serif",
          color: "var(--ish-dark)",
        }}
      >
        Three Phases of Sade Sati
      </h2>
      <div className="space-y-4">
        <div
          className="p-4 rounded-lg"
          style={{
            backgroundColor: "rgba(234, 179, 8, 0.06)",
            border: "1px solid rgba(234, 179, 8, 0.2)",
          }}
        >
          <span
            className="text-[14px] font-bold"
            style={{ color: "var(--color-warning-text-dark)" }}
          >
            Phase 1: Rising (Ascending)
          </span>
          <span className="text-[12px] ml-2" style={{ color: "var(--color-warning-text-dark)" }}>
            ~2.5 years
          </span>
          <p className="text-[13px] mt-2" style={{ color: "var(--ish-text-muted)" }}>
            The opening phase usually feels like preparation: budgets tighten, rest needs
            protection, and hidden worries become visible. Use it to reduce leakage before pressure
            peaks.
          </p>
        </div>
        <div
          className="p-4 rounded-lg"
          style={{
            backgroundColor: "rgba(220, 38, 38, 0.06)",
            border: "1px solid rgba(220, 38, 38, 0.2)",
          }}
        >
          <span className="text-[14px] font-bold" style={{ color: "var(--color-error-text)" }}>
            Phase 2: Peak
          </span>
          <span className="text-[12px] ml-2" style={{ color: "var(--color-error-text)" }}>
            ~2.5 years
          </span>
          <p className="text-[13px] mt-2" style={{ color: "var(--ish-text-muted)" }}>
            The middle phase tests identity and steadiness. Public duties, health routines,
            confidence, and emotional stamina need a simpler structure, not dramatic reactions.
          </p>
        </div>
        <div
          className="p-4 rounded-lg"
          style={{
            backgroundColor: "rgba(249, 115, 22, 0.06)",
            border: "1px solid rgba(249, 115, 22, 0.2)",
          }}
        >
          <span
            className="text-[14px] font-bold"
            style={{ color: "var(--color-warning-orange-dark)" }}
          >
            Phase 3: Setting (Descending)
          </span>
          <span className="text-[12px] ml-2" style={{ color: "var(--color-warning-orange-dark)" }}>
            ~2.5 years
          </span>
          <p className="text-[13px] mt-2" style={{ color: "var(--ish-text-muted)" }}>
            The closing phase asks you to stabilize speech, family expectations, stored money, and
            food discipline. What was learned earlier starts becoming usable judgment.
          </p>
        </div>
      </div>
    </div>
  );
}
